import { render, staticRenderFns } from "./IcdCodesList.vue?vue&type=template&id=6f137209&scoped=true&"
import script from "./IcdCodesList.vue?vue&type=script&lang=js&"
export * from "./IcdCodesList.vue?vue&type=script&lang=js&"
import style0 from "./IcdCodesList.vue?vue&type=style&index=0&id=6f137209&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f137209",
  null
  
)

export default component.exports